/**
 * Customer360.tsx
 *
 * Page component for displaying the 360-degree customer view with Power BI integration.
 */
import React, { useEffect } from "react";
import styles from "../../styles/pages/Customers/Customer360.module.css";
import {Customer360ViewModel} from "../../viewmodel/customer360";
import { POWER_BI_ACTIVE_TAB_OPTIONS } from "../../constant/enum";

/**
 * Customer360
 * Renders the customer 360 view page with Power BI report and tab selection.
 */
const Customer360 = () => {
  const {
    reportRef,
    embedData,
    customerId,
    error,
    activeTab,
    setActiveTab,
  } = Customer360ViewModel();

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";
    return () => {
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.overflow = "";
      document.documentElement.style.height = "";
      document.body.style.height = "";
    };
  }, []);

  if (error) {
    return (
      <div className={styles.reportContainer}>
        <div style={{ color: "#c00", fontWeight: 500, fontSize: "1.2em", display: "flex", height: "100vh", alignItems: "center", justifyContent: "center" }}>
          Error: {error}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container} style={{ backgroundColor: 'white',marginTop: '8px' }}>
      <div className={styles.sidebar}>
        <button
          className={activeTab ===POWER_BI_ACTIVE_TAB_OPTIONS.PATTERNS ? styles.active : ""}
          onClick={() => setActiveTab(POWER_BI_ACTIVE_TAB_OPTIONS.PATTERNS)}
         
        >
          Patterns
        </button>
        <button
          className={activeTab === POWER_BI_ACTIVE_TAB_OPTIONS.HEALTH ? styles.active : ""}
          onClick={() => setActiveTab(POWER_BI_ACTIVE_TAB_OPTIONS.HEALTH)}
        >
          Health
        </button>
      </div>

      <div className={styles.reportContainer}>
        <React.Suspense fallback={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}><span style={{ fontSize: "1.3em", color: "#555" }}>Loading Power BI report...</span></div>}>
          {!embedData || !customerId ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
              <span style={{ fontSize: "1.3em", color: "#555" }}>Loading Power BI report...</span>
            </div>
          ) : (
            <div ref={reportRef} className={styles.reportEmbed} />
          )}
        </React.Suspense>
      </div>
    </div>
  );
};

export default React.memo(Customer360);
